import { useMemo } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { NotificationsHomeScreen } from '../screens/notifications/NotificationsHomeScreen';
import { InboxReadingScreen } from '../screens/inbox/InboxReadingScreen';
import { useTheme } from '../contexts/ThemeContext';

export type NotificationsNavigatorParamList = {
  NotificationsHome: undefined;
  InboxReading: { itemId: string };
};

const Stack = createStackNavigator<NotificationsNavigatorParamList>();

export function NotificationsNavigator() {
  const { theme } = useTheme();
  const { t } = useTranslation();

  // Same themed header block as DashboardNavigator/PortfolioNavigator —
  // without it the stack falls back to React Navigation's default white
  // header, which clashes with the dark Kinetic theme.
  const headerStyles = useMemo(
    () => ({
      headerStyle: {
        backgroundColor: theme.colors.surface,
        borderBottomWidth: theme.id === 'bauhaus' ? 2 : 1,
        borderBottomColor: theme.colors.border,
        elevation: 0,
      },
      headerTitleStyle: {
        fontSize: theme.typography.fontSizeLg,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.colors.text,
        textTransform: theme.id === 'bauhaus' ? 'uppercase' : 'none',
        letterSpacing: theme.id === 'bauhaus' ? -0.5 : 0,
      },
      headerTintColor: theme.colors.primary,
    }),
    [theme]
  );

  return (
    <Stack.Navigator screenOptions={{ headerShown: true, ...headerStyles }}>
      <Stack.Screen
        name="NotificationsHome"
        component={NotificationsHomeScreen}
        options={{ title: t('tabs.notifications', { defaultValue: 'Notifications' }) }}
      />
      <Stack.Screen
        name="InboxReading"
        component={InboxReadingScreen}
        options={{ title: t('inbox.report', { defaultValue: 'Report' }) }}
      />
    </Stack.Navigator>
  );
}
